import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, Modal, Table } from "react-bootstrap";
import LockIcon from "../../icons/LockIcon";
import "./style.scss";
import SearchIcon from "../../icons/SearchIcon";
import BusinessIcon from "../../icons/BusinessIcon";
import CalendarIcon from "../../icons/CalendarIcon";
import FilterIcon from "../../icons/FilterIcon";
import { confirmCheckin, getTodayCheckins } from "../../services/checkin.service";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { getBookingDetails } from "../../services/bookings.service";
import { formatBookingTime } from "../../utils";

export default function CheckIn() {
  const [show, setShow] = useState(false);
  const [checkinlist, setCheckinlist] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);  // Track current page
  const [totalItems, setTotalItems] = useState<number>(0);  // Track total number of items
  const itemsPerPage = 10; // Number of items per page
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [uniqueCode, setUniqueCode] = useState<string>(''); // State for unique code
  const [isCodeValid, setIsCodeValid] = useState<boolean>(true); // State for validation status
  const [filterOption, setFilterOption] = useState<string>('newToOld');
  const [selectedBooking, setSelectedBooking] = useState<any>(null); // To hold selected booking details
  const [showBookingModal, setShowBookingModal] = useState<any>(false);
  const handleClose = () => {
    setShow(false);
    setSelectedBooking(null);
    setShowBookingModal(false)
  };
  const handleShow = async (bookingId: string) => {
    setShowBookingModal(false)
    setShow(true);
    try {
      const result = await getBookingDetails(bookingId);
      setSelectedBooking(result?.data?.data || null);
    } catch (error) {
      console.error("Failed to fetch booking details:", error);
      setSelectedBooking(null);
    }
  };

  useEffect(() => {
    getCheckinlist(currentPage, searchTerm, filterOption);
  }, [currentPage, searchTerm, filterOption]);

  const getCheckinlist = async (page: number, searchTerm: string, filterOption: string,) => {
    let skip = (page - 1) * itemsPerPage;

    try {
      const payload = {
        search: searchTerm,
        sortOrder: filterOption,
        skip,
        limit: itemsPerPage,
      };
      const result = await getTodayCheckins(payload);
      setCheckinlist(result?.data?.data || []);
      setTotalItems(result?.data?.totalRecord || 0)
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Update filter option state
  const handleFilterChange = (filter: string) => {
    setFilterOption(filter);
    setCurrentPage(1);  // Reset to page 1 when filter changes

    getCheckinlist(currentPage, searchTerm, filter);
  };

  const handleConfirmCheckin = async () => {
    if (!uniqueCode.trim()) {
      toast.error("Please enter a valid unique code");
      return;
    }

    // Validate length and numeric content
    const isValidCode = /^\d{7}$/.test(uniqueCode);
    if (!isValidCode) {
      toast.error("Unique code must be exactly 7 digits and numeric only");
      return;
    }

    try {
      const result = await confirmCheckin(uniqueCode);
      if (result?.data?.responseCode !== 200) {
        toast.error(result?.data?.responseMessage);
        return;
      }
      setShowBookingModal(true)
      setShow(true);
      const res = await getBookingDetails(result?.data?.data?.id);
      setSelectedBooking(res?.data?.data || null);
      setUniqueCode('');
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage);
      }
    }
  };

  const handleUniqueCodeChange = (value: string) => {
    const isValid = /^\d{0,7}$/.test(value); // Allow up to 7 numeric characters
    setIsCodeValid(isValid);

    if (isValid) {
      setUniqueCode(value); // Update the unique code if valid
    }
  };

  // Using centralized date formatting utility



  return (
    <>
      <div className="CheckIn">
        <div className="container">
          <h3>Check-in</h3>
          <div className="row">
            <div className="col-md-6">
              <div className="bookingBlock">
                <h2>Enter booking unique code</h2>
                <form>
                  <div className="form-group ">
                    <div className="my-5 group-img iconLeft  position-relative textareaWrap">
                      <label>
                        <LockIcon />
                      </label>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Input unique code"
                          className="commonInput"
                          value={uniqueCode} // Bind input value to state
                          onChange={(e) =>
                            handleUniqueCodeChange(e.target.value)
                          } // Validate input on change
                        />
                      </Form.Group>
                    </div>
                    <Button
                      className="contniueBtn w-100"
                      onClick={() => handleConfirmCheckin()}
                    >
                      Continue
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-6"></div>
          </div>

          <div className="bgFormColor p-4 my-4">
            <div className="searchTitleWrap d-flex justify-content-between align-items-start">
              <label>Today check-in’s</label>
              <div className="searchWrap d-flex gap-2 align-items-center">
                <form>
                  <button>
                    <SearchIcon />
                  </button>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search check-in ..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </form>

                <div className="filterDropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <FilterIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <button
                        className={filterOption === "newToOld" ? "active" : ""}
                        onClick={() => handleFilterChange("newToOld")}
                      >
                        Date, new to old
                      </button>
                      <button
                        className={filterOption === "oldToNew" ? "active" : ""}
                        onClick={() => handleFilterChange("oldToNew")}
                      >
                        Date, old to new
                      </button>
                      <button
                        className={filterOption === "aToZ" ? "active" : ""}
                        onClick={() => handleFilterChange("aToZ")}
                      >
                        Alphabetically, A-Z
                      </button>
                      <button
                        className={filterOption === "zToA" ? "active" : ""}
                        onClick={() => handleFilterChange("zToA")}
                      >
                        Alphabetically, Z-A
                      </button>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table className="tableWrapper">
                <thead>
                  <tr>
                    <th>Class name</th>
                    <th>Booking date time</th>
                    <th>Visitor Name</th>
                    <th>Check-in time</th>
                    <th>Status / Action</th>
                  </tr>
                </thead>

                <tbody>
                  {checkinlist?.length > 0 ? (
                    checkinlist.map((booking, index) => (
                      <tr>
                        <td>
                          <span className="underline">
                            {booking?.className.charAt(0).toUpperCase() +
                              booking?.className.slice(1)}
                          </span>
                        </td>
                        <td>
                          {booking?.bookingStartDateTime
                            ? formatBookingTime(booking?.bookingStartDateTime)
                            : "-"}
                        </td>

                        <td>{`${booking?.employeeDetails?.firstName.charAt(0).toUpperCase() + booking?.employeeDetails?.firstName.slice(1)} ${booking?.employeeDetails?.lastName.charAt(0).toUpperCase() + booking?.employeeDetails?.lastName.slice(1)}`}</td>
                        <td>
                          {booking?.checkinTime
                            ? formatBookingTime(booking?.checkinTime)
                            : "-"}
                        </td>
                        <td>
                          <div className="d-flex gap-2 align-items-center action_result">
                            <span
                              className={
                                booking?.status?.toLowerCase() === "check-in"
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {booking?.status.charAt(0).toUpperCase() +
                                booking?.status.slice(1)}
                            </span>
                            <button
                              onClick={() => handleShow(booking?._id)}
                              className="confirmBtn"
                            >
                              Details
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        No check-in's found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      {/* modal start */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="confirmModal"
      >
        <Modal.Header closeButton>
          {showBookingModal && (
            <Modal.Title id="contained-modal-title-vcenter">
              Booking
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {selectedBooking ? (
            <div>
              {!showBookingModal && (
                <div className="modalImg">
                  <img
                    className="w-100"
                    src={"/assets/img/modalImage.jpg"}
                    alt="modalImage"
                  />
                </div>
              )}
              <div className="game_content">
                {!showBookingModal && (
                  <>
                    <label>
                      <BusinessIcon />{" "}
                      <span className="underline">
                        {selectedBooking?.partnerDetails?.businessName
                          ? selectedBooking?.partnerDetails?.businessName
                          : selectedBooking?.partnerDetails?.name}
                      </span>
                    </label>
                    <h2>
                      {selectedBooking?.className.charAt(0).toUpperCase() +
                        selectedBooking?.className.slice(1)}
                    </h2>
                    <label className="dateWrap">
                      <CalendarIcon />
                      {selectedBooking?.bookingStartDateTime
                        ? formatBookingTime(selectedBooking?.bookingStartDateTime)
                        : "-"}
                    </label>
                  </>
                )}

                {showBookingModal && (
                  <div className="text-center">
                    <h3>Your check-in is confirmed</h3>
                    <p>Now you can join your class.</p>
                  </div>
                )}

                <div className="bgFormColor p-4 my-3">
                  <h3>Booking person details</h3>
                  <div className="bookDetail">
                    <ul>
                      <li className="d-flex justify-content-between">
                        <label>Full name :</label>
                        <h4>
                          {" "}
                          {`${selectedBooking?.employeeDetails?.firstName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.firstName.slice(1)} ${selectedBooking?.employeeDetails?.lastName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.lastName.slice(1)}`}
                        </h4>
                      </li>
                      <li className="d-flex justify-content-between">
                        <label>Email id :</label>
                        <h4> {selectedBooking?.employeeDetails?.email}</h4>
                      </li>
                      <li className="d-flex justify-content-between">
                        <label>Contact :</label>
                        <h4>{selectedBooking?.employeeDetails?.phone}</h4>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading booking details...</p>
          )}
        </Modal.Body>
        <Modal.Footer className="w-100 direction-column justify-content-center">
          {showBookingModal && (
            <Button
              onClick={() => {setShowBookingModal(false);setShow(false)}}
              className="contniueBtn w-100 mb-2"
            >
              Continue
            </Button>
          )}

          {selectedBooking?.status?.toLowerCase() !== "cancelled" &&
          selectedBooking?.status?.toLowerCase() !== "late cancelled" &&
            selectedBooking?.status?.toLowerCase() !== "checked-in" && (
              <div>
                <Button
                  onClick={() => handleShow(selectedBooking?._id)}
                  className="w-100 mb-2"
                >
                  Check-in
                </Button>

              </div>
            )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
